import {buildAssistantEntityContext, type AssistantEntityContext} from '@dms/ai-assistant';
import type {InterestResponseBodyV2Read} from '@dms/api/finance';

/**
 * Records loaded by a mounted sales-interest page. Returns `undefined` until the loaded interest
 * belongs to the route id. The business case and vehicle come from the same active-case entry.
 */
export const getInterestAssistantEntities = (
  interestId: string,
  interest:
    | Pick<InterestResponseBodyV2Read, 'activeBusinessCases' | 'customerId' | 'id' | 'publicId'>
    | undefined
): AssistantEntityContext | undefined => {
  if (interest?.id !== interestId) {
    return undefined;
  }

  const activeBusinessCase = interest.activeBusinessCases?.[0];
  const vehicleInfo = activeBusinessCase?.vehicleInfo;

  return buildAssistantEntityContext({
    interest: {id: interestId, label: interest.publicId},
    customer: interest.customerId,
    businessCase: activeBusinessCase && {
      id: activeBusinessCase.businessCaseId,
      label: activeBusinessCase.code,
    },
    vehicle:
      typeof vehicleInfo?.id === 'string'
        ? {id: vehicleInfo.id, label: vehicleInfo.title}
        : undefined,
  });
};
